export enum Flavor {
  MR = 'mr',
  ALMLR = 'almlr',
  FRTB = 'frtb',
  SACCR = 'saccr',
  CVA = 'cva',
  PA = 'pa',
  CCR = 'ccr',
}
